import './image-content.scss';

export default () => {

};
